import React, { useState, useEffect } from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_green.css";
import "flatpickr/dist/l10n/es.js"; // Importa el idioma español
import { getSessionHistory } from "../../../helpers/backend";
import {
  useParams,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import { Col, Container, Row, Button } from "reactstrap";
import { useSelector } from "react-redux";
import Table from "../../../components/Common/Table";
import ButtonVolver from "../../../components/ButtonVolver";

const SessionHistory = () => {
  const id = useParams().id;
  const historyHook = useHistory();
  const [history, setHistory] = useState([]);
  const [fechaInicio, setFechaInicio] = useState("");
  const [fechaFin, setFechaFin] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  useEffect(() => {
    fetchHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fechaInicio, fechaFin]);

  const fetchHistory = async () => {
    try {
      const response = await getSessionHistory(
        id,
        `&fecha_inicio=${fechaInicio}&fecha_fin=${fechaFin}`
      );
      setHistory(response.data);
    } catch (error) {
      console.error("Error fetching history:", error);
    }
  };

  const handleDateChange = (selectedDates) => {
    if (selectedDates.length === 2) {
      const [start, end] = selectedDates;
      setFechaInicio(start.toISOString().split("T")[0]); // Formato YYYY-MM-DD
      setFechaFin(end.toISOString().split("T")[0]); // Formato YYYY-MM-DD
      setSelectedDate(selectedDates);
    }
  };

  const exportToExcel = () => {};

  const theme = useSelector((state) => state.theme.theme) || "light";

  const handleGoBack = () => {
    historyHook.goBack();
  };
  console.log(history);

  // --- Configuración de la tabla ---
  const columns = [
    { key: "user", label: "Usuario", filterable: true },
    { key: "login_time", label: "Hora de Login", filterable: true },
    { key: "logout_time", label: "Hora de Logout", filterable: true },
    { key: "session_duration", label: "Duración de Sesión", filterable: true },
    {
      key: "total_pause_time",
      label: "Tiempo Total de Pausa",
      filterable: true,
    },
    { key: "net_work_time", label: "Tiempo Neto de Trabajo", filterable: true },
    { key: "pauses", label: "Pausas", filterable: false },
  ];

  const formattedData = Array.isArray(history)
    ? history.map((s) => ({
        user: s.user,
        login_time: s.login_time,
        logout_time: s.logout_time,
        session_duration: s.session_duration,
        total_pause_time: s.total_pause_time,
        net_work_time: s.net_work_time,
        pauses: (
          <ul
            style={{
              textAlign: "left",
              padding: 0,
              margin: 0,
              listStyle: "none",
            }}
          >
            {s.pauses.map((p) => (
              <li key={p.id}>
                {p.reason}: {p.comment} ({p.time_range})
              </li>
            ))}
          </ul>
        ),
      }))
    : [];

  return (
    <React.Fragment>
      <Container fluid>
        <div className="page-content">
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Historial de conexiones
            </span>
          </Col>
          <div className="d-flex py-4 px-4">
            <Row>
              <Col>
                <Flatpickr
                  className="form-control d-block"
                  placeholder="Fecha"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d",
                    locale: "es",
                    
                  }}
                  onChange={handleDateChange}
                  value={selectedDate}
                  style={{
                    backgroundColor:
                      theme === "dark" ? "#242424" : "#fff",
                    color: theme === "dark" ? "#c3cbe4" : "#000",
                    borderColor:
                      theme === "dark" ? "#1d2d42" : "#d2d2d2",
                      height:"33px"
                  }}
                />
              </Col>

              <Col>
                <Button
                  className="btn btn-sm "
                  color="success"
                  onClick={exportToExcel}
                >
                  Exportar a Excel
                </Button>
              </Col>
            </Row>
          </div>
          <Table data={formattedData} columns={columns} theme={theme} />
          <Row>
            <Col className="d-flex justify-content-center text-center py-4 mb-4">
              <Button
                className="btn btn-sm text-dark"
                color="secondary"
                onClick={handleGoBack}
              >
                Volver
              </Button>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default SessionHistory;
